import { useGet } from './useFetch'
import { useAuth } from './useAuth'
import { ApiResponse } from '@magnetar/admin-api-interfaces'

export interface SupplierClinic {
  clinic_id: number
  clinic_name: string
  clinic_ip: string
  manager_name: string
  phone: string
  address: string
  is_active: boolean
  alias: string | null
  tags: string[]
}

export interface UseSupplierClinicsParams {
  supplierId?: number
}

export function useSupplierClinics({ supplierId }: UseSupplierClinicsParams) {
  const { token } = useAuth()

  const { data, error, mutate, isLoading } = useGet<ApiResponse<SupplierClinic[]>>(
    token && supplierId ? `/api/ad-schedule-templates/supplier/${supplierId}/clinics` : null,
    undefined,
    token ?? '',
  )

  return {
    clinics: data?.data || [],
    isLoading,
    isError: error,
    mutate,
  }
}
